import styled from '@emotion/styled';
import { GroupBase, StylesConfig } from 'react-select';

import { HideScroll } from 'shared/styles/hide-scroll';
import done from 'ud-ui/components/icon/icons/done.svg';
import { SelectOption } from './types';
import { theme } from 'styles/theme/theme';

export const Option = styled.div`
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.SurfaceCultured10};
  }
`;

export const OptionCheckbox = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  border-radius: 4px;

  :after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
  }

  &[data-checked='true'] {
    background-color: ${({ theme }) => theme.colors.AccentNaplesYellow};
    &:after {
      background-image: url(${done});
      background-repeat: no-repeat;
      background-position: center;
      background-size: 14px;
    }
  }
  &[data-checked='false'] {
    background-color: ${({ theme }) => theme.colors.SurfacePlatinum20};
  }
`;

export const MultiValue = styled.div`
  display: flex;
  &:not(:first-child):before {
    content: ' ∙ ';
    display: block;
    color: ${({ theme }) => theme.colors.AccentNaplesYellow};
  }
`;

export const ValueContainer = styled.div`
  flex-wrap: nowrap;
  overflow-x: auto;
  padding-bottom: 50px;
  margin-bottom: -50px;

  ${HideScroll}
`;

export const Control = styled.div`
  background-color: ${({ theme }) => theme.colors.SurfaceWhite};
  border-radius: 8px;
  overflow: hidden;
  border-width: 1px;
  border-style: solid;
  border-color: ${theme.colors.WhiteGray50};
  position: relative;
  cursor: pointer;
  transition:
    border-radius 0.2s ease,
    border-color 0.2s ease;

  &.focused {
    border-color: ${({ theme }) => theme.colors.AccentNaplesYellow};
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &.opened {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  &::after {
    position: absolute;
    top: -10px;
    right: -6px;
    content: '';
    display: none;
    width: 15px;
    height: 30px;
    transform: rotate(-45deg);
    transition: background-color 0.2s ease-in-out;
  }

  &[data-error='true'] {
    border-color: ${({ theme }) => theme.colors.error};

    &:after {
      display: block;
      background-color: ${({ theme }) => theme.colors.error};
    }
  }
`;

export const SelectContainer = styled.div`
  position: relative;
  box-sizing: border-box;
`;

export const MenuList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  padding-bottom: 4px;
  padding-top: 4px;
  position: relative;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
`;

export const MenuInfo = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.BorderGray50};
`;

export function getSelectStyles<
  isMulti extends boolean,
  Group extends GroupBase<SelectOption> = GroupBase<SelectOption>,
>(): StylesConfig<SelectOption, isMulti, Group> {
  return {
    menu: ({ boxShadow, marginTop, ...otherBase }) => ({
      ...otherBase,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
}
